import React from 'react';
import classNames from 'classnames';
import path from 'path';
import api from 'api';
import { AppLink } from '../modules/routing/containers';

class OwnerMenu extends React.Component {
  constructor(props) {
    super(props);
    this.isActive = this.isActive.bind(this);
  }
  render() {
    return (
      <ul className="sidebar-menu">
        <li className={ classNames({ active: this.isActive('/overview') }) }>
          <AppLink to="/overview">
            <i className="fas fa-tachometer-alt"></i> <span>Dashboard</span>
          </AppLink>
        </li>
        <li className={ classNames({ active: this.isActive('/daily-rental/availabilities/calendar') }) }>
          <AppLink to="/daily-rental/availabilities/calendar">
            <i className="far fa-calendar-alt fa-fw"></i> <span>Calendar</span>
          </AppLink>
        </li>
      </ul>
    );
  }

  isActive(url) {
    const [pathname, searchParams] = url.split('?');
    return this.props.location.pathname.match(`^${this.resolveUrl(pathname)}`)
      && this.props.location.search.match(searchParams);
  }
  resolveUrl(url) {
    const root = this.props.root;
    return path.join(root, url);
  }
}

OwnerMenu.propTypes = {
  api: React.PropTypes.object,
  location: React.PropTypes.object,
  root: React.PropTypes.string,
};

export default OwnerMenu;



// WEBPACK FOOTER //
// ./src/frontend/layout/OwnerMenu.jsx